(function () {
  'use strict';

  if (window.__OBSIDIA_PRODUCT_GATE__) {
    return;
  }

  window.__OBSIDIA_PRODUCT_GATE__ = true;


  /*
   * MASTER RESTRICTED SKU LIST
   *
   * Add or remove restricted SKUs here only.
   */
  var RESTRICTED_SKUS = [
    'BR10011',
    'BR10015',
    'BR10016',
    'R13660',
    'R13657',
    'R13046',
    'R13769',
    'BR10017',
    'R13771',
    'R13782',
    'R13779',
    'BR10018',
    'R13814',
    'R12841',
    'R13840',
    'R13842',
    'R13847',
    'R12566',
    'R13626',
    'R13910',
    'R13866',
    'R13898',
    'BR10020',
    'R13780',
    'R13919',
    'R13920',
    'GIVEAWAY',
    'R13879',
    'R13929',
    'R13928',
    'R13870',
    'R13874',
    'BR10021',
    'R13869',
    'BR10022',
    'R13961',
    'R13968',
    'R13970',
    'R13971',
    'R13992',
    'R13930',
    'R13931',
    'R13932',
    'BR10023',
    'R13994',
    'R13995',
    'BR10024',
    'R14069',
    'R13208',
    'R13037',
    'R14071',
    'R14030',
    'R14032',
    'R14088',
    'R14098',
    'R14034',
    'R12842',
    'R13447',
    'R14166',
    'R14165',
    'R14137',
    'R14150',
    'R14151',
    'R14153',
    'R14154',
    'R14155',
    'R14156',
    'R14131',
    'R14133',
    'R14134',
    'R14230',
    'R14159',
    'R14161',
    'R14157'
  ];


  var restrictedSkuMap = {};


  function normalise(value) {
    return (value || '')
      .toString()
      .trim()
      .toUpperCase();
  }


  RESTRICTED_SKUS.forEach(
    function (sku) {
      restrictedSkuMap[
        normalise(sku)
      ] = true;
    }
  );


  function parseJSON(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  }


  function isRestrictedSku(sku) {
    return (
      restrictedSkuMap[
        normalise(sku)
      ] === true
    );
  }


  function getCustomerContext(element) {
    if (!element) {
      return {
        loggedIn: false,
        tags: []
      };
    }

    return {
      loggedIn:
        element.getAttribute(
          'data-obsidia-logged-in'
        ) === 'true',

      tags:
        parseJSON(
          element.getAttribute(
            'data-obsidia-customer-tags'
          ),
          []
        )
    };
  }


  function hasMatchingSkuTag(
    customerContext,
    sku
  ) {
    if (!customerContext.loggedIn) {
      return false;
    }

    var requiredSku =
      normalise(sku);

    for (
      var i = 0;
      i < customerContext.tags.length;
      i++
    ) {
      if (
        normalise(
          customerContext.tags[i]
        ) === requiredSku
      ) {
        return true;
      }
    }

    return false;
  }


  function isBlocked(
    customerContext,
    sku
  ) {
    return (
      isRestrictedSku(sku) &&
      !hasMatchingSkuTag(
        customerContext,
        sku
      )
    );
  }


  function getBlockedMessage(
    customerContext
  ) {
    return customerContext.loggedIn
      ? 'Invite only. Join the lottery to be considered.'
      : 'Please log in to purchase this product.';
  }


  /*
   * PRODUCT CARD ERRORS
   */

  function showCardError(
    button,
    message
  ) {
    var wrapper =
      button.closest(
        '.product-card--add-to-cart-button-wrapper'
      ) ||
      button.parentElement;

    if (!wrapper) {
      return;
    }

    var errorBox =
      wrapper.querySelector(
        '.fc-gate-error'
      );

    if (!errorBox) {
      errorBox =
        document.createElement('div');

      errorBox.className =
        'fc-gate-error form-notification error';

      errorBox.style.marginTop =
        '8px';

      wrapper.appendChild(
        errorBox
      );
    }

    errorBox.textContent =
      message;

    errorBox.style.display =
      '';
  }


  function clearCardError(button) {
    var wrapper =
      button.closest(
        '.product-card--add-to-cart-button-wrapper'
      );

    if (!wrapper) {
      return;
    }

    var errorBox =
      wrapper.querySelector(
        '.fc-gate-error'
      );

    if (errorBox) {
      errorBox.textContent = '';

      errorBox.style.display =
        'none';
    }
  }


  /*
   * PRODUCT FORM HELPERS
   */

  function getProductFormFromElement(
    element
  ) {
    if (!element) {
      return null;
    }

    if (element.closest) {
      var directProductForm =
        element.closest(
          'product-form[data-obsidia-product-form]'
        );

      if (directProductForm) {
        return directProductForm;
      }


      var section =
        element.closest(
          '[id^="shopify-section-"]'
        );

      if (section) {
        var sectionProductForm =
          section.querySelector(
            'product-form[data-obsidia-product-form]'
          );

        if (sectionProductForm) {
          return sectionProductForm;
        }
      }
    }

    return null;
  }


  function getVariants(productForm) {
    return parseJSON(
      productForm.getAttribute(
        'data-obsidia-variants'
      ),
      []
    );
  }


  function getSelectedVariant(
    productForm
  ) {
    var form =
      productForm.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

    if (!form) {
      return null;
    }

    var variantInput =
      form.querySelector(
        'input[name="id"]'
      );

    if (
      !variantInput ||
      !variantInput.value
    ) {
      return null;
    }

    var currentVariantId =
      String(
        variantInput.value
      );

    var variants =
      getVariants(productForm);

    for (
      var i = 0;
      i < variants.length;
      i++
    ) {
      if (
        String(
          variants[i].id
        ) === currentVariantId
      ) {
        return variants[i];
      }
    }

    return null;
  }


  function getProductFormState(
    productForm
  ) {
    var variant =
      getSelectedVariant(
        productForm
      );

    var customerContext =
      getCustomerContext(
        productForm
      );

    var sku =
      variant && variant.sku
        ? variant.sku
        : '';

    var available =
      variant
        ? variant.available === true
        : false;

    return {
      sku: sku,

      available: available,

      customerContext:
        customerContext,

      blocked:
        isBlocked(
          customerContext,
          sku
        )
    };
  }


  /*
   * PRODUCT PAGE ERROR MESSAGE
   */

  function getErrorWrapper(
    productForm
  ) {
    return productForm.querySelector(
      '.product-form__error-message-wrapper'
    );
  }


  function showProductError(
    productForm,
    message
  ) {
    var errorWrapper =
      getErrorWrapper(
        productForm
      );

    if (!errorWrapper) {
      return;
    }

    var errorText =
      errorWrapper.querySelector(
        '.product-form__error-message'
      );

    if (!errorText) {
      return;
    }

    errorText.textContent =
      message;

    errorWrapper.hidden =
      false;

    errorWrapper.style.display =
      '';

    if (
      typeof errorWrapper.scrollIntoView ===
      'function'
    ) {
      errorWrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }


  function clearProductError(
    productForm
  ) {
    var errorWrapper =
      getErrorWrapper(
        productForm
      );

    if (!errorWrapper) {
      return;
    }

    var errorText =
      errorWrapper.querySelector(
        '.product-form__error-message'
      );

    if (errorText) {
      errorText.textContent = '';
    }

    errorWrapper.hidden = true;

    errorWrapper.style.display =
      'none';
  }


  /*
   * MAIN + STICKY ADD TO CART BUTTONS
   */

  function getProductButtons(
    productForm
  ) {
    var buttons = [];


    var mainButton =
      productForm.querySelector(
        '#AddToCart'
      );

    if (mainButton) {
      buttons.push(
        mainButton
      );
    }


    var sectionId =
      productForm.getAttribute(
        'data-section'
      );


    if (sectionId) {
      var section =
        document.getElementById(
          'shopify-section-' +
          sectionId
        );

      if (section) {
        var sectionStickyButton =
          section.querySelector(
            '#AddToCartSticky'
          );

        if (
          sectionStickyButton &&
          buttons.indexOf(
            sectionStickyButton
          ) === -1
        ) {
          buttons.push(
            sectionStickyButton
          );
        }
      }
    }


    var globalStickyButton =
      document.getElementById(
        'AddToCartSticky'
      );

    if (
      globalStickyButton &&
      buttons.indexOf(
        globalStickyButton
      ) === -1
    ) {
      buttons.push(
        globalStickyButton
      );
    }


    return buttons;
  }


  function updateButton(
    button,
    state
  ) {
    if (!button) {
      return;
    }


    button.dataset
      .obsidiaBlocked =
      state.blocked
        ? '1'
        : '0';


    button.classList.toggle(
      'sold-out',
      state.blocked ||
      !state.available
    );


    button.classList.toggle(
      'accent',
      state.available &&
      !state.blocked
    );


    if (state.blocked) {
      button.type = 'button';

      button.removeAttribute(
        'disabled'
      );

      button.setAttribute(
        'aria-disabled',
        'true'
      );

      button.setAttribute(
        'title',
        getBlockedMessage(
          state.customerContext
        )
      );

      return;
    }


    button.type = 'submit';


    button.removeAttribute(
      'aria-disabled'
    );


    button.removeAttribute(
      'title'
    );


    if (state.available) {
      button.removeAttribute(
        'disabled'
      );
    } else {
      button.setAttribute(
        'disabled',
        'disabled'
      );
    }
  }


  /*
   * APPLY LOCK TO PRODUCT PAGE
   */

  function updateProductForm(
    productForm
  ) {
    if (!productForm) {
      return;
    }


    var state =
      getProductFormState(
        productForm
      );


    var buttons =
      getProductButtons(
        productForm
      );


    for (
      var i = 0;
      i < buttons.length;
      i++
    ) {
      updateButton(
        buttons[i],
        state
      );
    }


    var paymentButton =
      productForm.querySelector(
        '.shopify-payment-button'
      );


    if (paymentButton) {
      if (state.blocked) {
        paymentButton.style.display =
          'none';
      } else {
        paymentButton.style
          .removeProperty(
            'display'
          );
      }
    }


    if (!state.blocked) {
      clearProductError(
        productForm
      );
    }
  }


  function initialiseProductForm(
    productForm
  ) {
    if (!productForm) {
      return;
    }


    if (
      productForm.dataset
        .obsidiaGateInitialised ===
      '1'
    ) {
      updateProductForm(
        productForm
      );

      return;
    }


    productForm.dataset
      .obsidiaGateInitialised =
      '1';


    var form =
      productForm.querySelector(
        'form[data-type="add-to-cart-form"]'
      );


    if (form) {
      form.addEventListener(
        'change',
        function () {
          window.setTimeout(
            function () {
              updateProductForm(
                productForm
              );
            },
            0
          );
        }
      );


      form.addEventListener(
        'input',
        function (event) {
          if (
            event.target &&
            event.target.name ===
              'id'
          ) {
            window.setTimeout(
              function () {
                updateProductForm(
                  productForm
                );
              },
              0
            );
          }
        }
      );
    }


    var variantInput =
      productForm.querySelector(
        'input[name="id"]'
      );


    if (
      variantInput &&
      'MutationObserver' in window
    ) {
      new MutationObserver(
        function () {
          updateProductForm(
            productForm
          );
        }
      ).observe(
        variantInput,
        {
          attributes: true,
          attributeFilter: [
            'value'
          ]
        }
      );
    }


    updateProductForm(
      productForm
    );


    window.setTimeout(
      function () {
        updateProductForm(
          productForm
        );
      },
      250
    );
  }


  function initialiseAllProductForms() {
    var productForms =
      document.querySelectorAll(
        'product-form[data-obsidia-product-form]'
      );


    for (
      var i = 0;
      i < productForms.length;
      i++
    ) {
      initialiseProductForm(
        productForms[i]
      );
    }
  }


  /*
   * COLLECTION / SEARCH QUICK ADD
   */

  document.addEventListener(
    'click',
    function (event) {

      var productCardButton =
        event.target &&
        event.target.closest
          ? event.target.closest(
              'button.product-card--add-to-cart-button-simple[data-sku]'
            )
          : null;


      if (productCardButton) {
        clearCardError(
          productCardButton
        );


        var productCard =
          productCardButton.closest(
            'product-card[data-obsidia-product-card]'
          );


        if (!productCard) {
          return;
        }


        var sku =
          productCardButton.getAttribute(
            'data-sku'
          ) || '';


        var customerContext =
          getCustomerContext(
            productCard
          );


        if (
          isBlocked(
            customerContext,
            sku
          )
        ) {
          event.preventDefault();

          event.stopPropagation();


          if (
            event.stopImmediatePropagation
          ) {
            event.stopImmediatePropagation();
          }


          showCardError(
            productCardButton,
            getBlockedMessage(
              customerContext
            )
          );


          return false;
        }


        return;
      }


      /*
       * PRODUCT PAGE / STICKY BUTTON
       */

      var productButton =
        event.target &&
        event.target.closest
          ? event.target.closest(
              '#AddToCart, #AddToCartSticky'
            )
          : null;


      if (!productButton) {
        return;
      }


      var productForm =
        getProductFormFromElement(
          productButton
        );


      if (!productForm) {
        return;
      }


      var state =
        getProductFormState(
          productForm
        );


      if (!state.blocked) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        event.stopImmediatePropagation
      ) {
        event.stopImmediatePropagation();
      }


      showProductError(
        productForm,
        getBlockedMessage(
          state.customerContext
        )
      );


      return false;

    },
    true
  );


  /*
   * FORM SUBMISSION BACKUP GUARD
   */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (
        !form ||
        !form.closest
      ) {
        return;
      }


      var productForm =
        form.closest(
          'product-form[data-obsidia-product-form]'
        );


      if (!productForm) {
        return;
      }


      var state =
        getProductFormState(
          productForm
        );


      if (!state.blocked) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        event.stopImmediatePropagation
      ) {
        event.stopImmediatePropagation();
      }


      showProductError(
        productForm,
        getBlockedMessage(
          state.customerContext
        )
      );

    },
    true
  );


  /*
   * STICKY VARIANT CHANGES
   */

  document.addEventListener(
    'change',
    function (event) {

      var target =
        event.target;


      if (
        !target ||
        !target.closest
      ) {
        return;
      }


      var stickyVariantSelector =
        target.closest(
          'variant-selects[data-sticky="1"]'
        );


      if (
        stickyVariantSelector
      ) {
        window.setTimeout(
          initialiseAllProductForms,
          0
        );
      }

    }
  );


  /*
   * SHOPIFY THEME EDITOR
   */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initialiseAllProductForms();
    }
  );


  /*
   * QUICK VIEW / DYNAMIC CONTENT
   */

  if (
    'MutationObserver' in window
  ) {
    new MutationObserver(
      function (mutations) {

        for (
          var i = 0;
          i < mutations.length;
          i++
        ) {
          if (
            mutations[i].addedNodes &&
            mutations[i].addedNodes.length
          ) {
            initialiseAllProductForms();

            break;
          }
        }

      }
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /*
   * INITIAL LOAD
   */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllProductForms
    );
  } else {
    initialiseAllProductForms();
  }

})();